import Native from '../js/Native';
import Sound = createjs.Sound;
import WebAudioPlugin = createjs.WebAudioPlugin;

enum Audibility {
  Muted = 0,
  Unmuted = 1,
}
class SoundManager {
  public static Audibility;
  /**
   * Mutes/unmutes the current sound and sets global state of audibility
   */
  public static set audibility(audibilityEnum: Audibility) {
    SoundManager._audibility = audibilityEnum;

    if (SoundManager.lastSoundInstance) {
      SoundManager.lastSoundInstance.volume = SoundManager.getAudibleVolume();
    }
  }
  /**
   * Returns the current audibility state
   */
  public static get audibility(): Audibility {
    return SoundManager._audibility;
  }
  public static lastSoundInstance: createjs.AbstractSoundInstance = null;

  public static getAudibleVolume(): number {
    return SoundManager.audibility;
  }
  public static playSound(sound) {
    if (!Native.isSoundEnabled()) {
      return null;
    }

    SoundManager.stop();

    console.log('Playing: ' + sound);
    try {
      SoundManager.tryResumeWebAudioContext();

      SoundManager.lastSoundInstance = Sound.play(sound, {
        loop: 0,
        volume: SoundManager.getAudibleVolume(),
      });
      return SoundManager.lastSoundInstance;
    } catch (e) {
      // we're probably trying to play sound outside of a touch event (via callbacks)
      console.log(e);
      return null;
    }
  }

  /**
   * Stop the currently playing sound, if playing.
   */
  public static stop() {
    if (!SoundManager.lastSoundInstance) {
      return;
    }

    try {
      SoundManager.lastSoundInstance.stop();
    } catch (e) {
      console.log('Could not stop sound', e);
    }
    SoundManager.lastSoundInstance = null;
  }
  public static playSounds(sounds: string[], cb: () => void = null) {
    console.log('playSounds:', sounds);
    if (sounds.length === 0) {
      if (cb) {
        cb();
      }
      return;
    }

    const first = sounds[0];
    const snd = this.playSound(first);
    const nextCb = () => this.playSounds(sounds.slice(1), cb);

    if (snd) {
      snd.on('complete', nextCb);
      snd.on('failed', () => {
        console.log('playback failed for ', snd);
        nextCb();
      });
    } else {
      // sound muted?
      nextCb();
    }
  }
  private static _audibility: Audibility = Audibility.Unmuted;
  // Under iOS, the web audio context is sometimes suspended when the webview
  // is backgrounded. Try to resume it.
  private static tryResumeWebAudioContext() {
    try {
      // If there is no audio context, nothing to resume
      // (or not using WebAudioPlugin?)
      if (!WebAudioPlugin.context) {
        return;
      }

      // Use 'any', as the typescript definition of context-state does not include all iOS states (like 'interrupted')
      const contextState: any = WebAudioPlugin.context.state;

      if (contextState === 'suspended' || contextState === 'interrupted') {
        console.log('Audio context state:' + WebAudioPlugin.context.state);
        WebAudioPlugin.context.resume();
        console.log('Resumed suspended audio context');
      }
    } catch (e) {
      // ignore.
    }
  }
}
SoundManager.Audibility = Audibility;

export default SoundManager;
